<template>
    <div class="form__group">
        <h4>{{title}}</h4>
        <textarea :disabled="disabled" @input="$emit('input', $event.target.value)" :id="id" class="form__field"
                  v-model="textInput" rows="6"></textarea>
        <!--<label :for="id" class="form__label">{{title}}</label>-->
    </div>
</template>

<script>
    export default {
        name: "TextArea",
        props: ["title", "text", "id", "disabled"],
        data() {
            return {
                textInput: this.text
            };
        }
    }
</script>

<style lang="scss" scoped>
    h4 {
        margin-top: 10px;
        margin-bottom: 8px;
        padding-left: 7px;
    }

    .form__group {
        position: relative;
    }

    .form__field {
        font-family: inherit;
        width: 100%;
        border: 0;
        border-bottom: 1px solid #d2d2d2;
        outline: 0;
        font-size: 16px;
        color: #212121;
        padding: 7px;
        background: #fff;
        transition: border-color 0.2s;
        resize: none;

        &:disabled {
            background: transparent;
        }
    }

    .form__field::placeholder {
        color: transparent;
    }

    .form__field:placeholder-shown ~ .form__label {
        font-size: 16px;
        cursor: text;
        top: 20px;
    }

    label,
    .form__field:focus ~ .form__label {
        position: absolute;
        top: 0;
        display: block;
        transition: 0.2s;
        font-size: 12px;
        color: #394956;
    }

    .form__field:focus ~ .form__label {
        color: #00b6ed;
    }

    .form__field:focus {
        padding-bottom: 6px;
        border-bottom: 2px solid #00b6ed;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 8px;

        &:hover {
            cursor:default;
        }
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #e4e4e4;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #caced4;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #b8bcc2;
        cursor: default;
    }
</style>